import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import Hint from '../../components/Hint/Hint';
import { useMenu } from "../../contexts/MenuContext";
import "./Dashboard.scss";
const customStyles = {
    overlay: {
        backgroundColor:'#1115199E',
        zIndex: '99999',
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '100%',
        maxWidth: '900px',
        padding: '0px',
        borderRadius: '8px',
        border: '1px solid rgb(216, 217, 219)',
    },
};
Modal.setAppElement('#ultimate-security-settings');
export default function Dashboard() {	
	const {
		settingData
	} = useMenu();  
    const [logs, setLogs] = useState([]);
    const [totalFailed, setTotalFailed] = useState(0);
    const [recentFailed, setRecentFailed] = useState(0);
	const [updatedPluginList, setUpdatedPluginList] = useState([]);
	const [outdatedPLuginsNumber, setOutdatedPLuginsNumber] = useState(0);
	const [siteHealthReport, setSiteHealthReport] = useState([]);
	const [siteHealthStatus, setSiteHealthStatus] = useState('');
	const [totalIssues, setTotalIssues] = useState(0);
	const [criticalThreats, setCriticalThreats] = useState(0);
	const [loading, setLoading] = useState(false);
	const [enabledScore, setEnabledScore] = useState(0);

	useEffect(() => {
		let score = 0;
		if (Object.values(settingData).length) {
			if (settingData?.login?.active_logins?.enable == 1) score += 1;

			if (settingData?.security?.login_security?.current_banner_content_enable == 1) score += 1;

			if (settingData?.security?.password_policies?.activate_password_policies == 1) score += 1;
			// if (settingData?.security?.password_policies?.min_length >= 13) score += 1;
			if (settingData?.security?.password_policies?.ui_rules_mix_case == 1) score += 1;
			if (settingData?.security?.password_policies?.ui_rules_numeric == 1) score += 1;
			if (settingData?.security?.password_policies?.ui_rules_special_chars == 1) score += 1;
			if (settingData?.security?.password_policies?.ui_rules_exclude_special_chars == 1 && settingData?.security?.password_policies?.excluded_special_chars != "") score += 1;
			if (settingData?.security?.password_policies?.change_initial_password == 1) score += 1;
			if (settingData?.security?.password_policies?.disable_self_reset == 1) score += 1;

			if (settingData?.security?.use_admin_password?.enable == 1) score += 1;

			if (settingData?.login?.express_login?.enable == 1) score += 1;
			if (settingData?.login?.express_login?.enable_link_expiry == 1) score += 1;

			if (settingData?.security?.['2fa_authentication']?.['2fa_enable'] == 1) score += 1;
			if (settingData?.security?.['2fa_authentication']?.['2fa_email_verification_enable'] == 1) score += 1;
			if (settingData?.security?.['2fa_authentication']?.['2fa_application_authentication_enable'] == 1) score += 1;

			if (settingData?.security?.re_captcha?.enable == 1) score += 1;
			if (settingData?.security?.re_captcha?.no_conflict_mode == 1) score += 1;
			if (settingData?.security?.re_captcha?.enable_woocommerce == 1) score += 1;

			if (settingData?.security?.cloudflare_turnstile?.disable_submit_button == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.defer_scripts == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.extra_failure_message == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.logged_in_users == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.wordpress_login == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.wordpress_register == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.wordpress_reset_password == 1) score += 1;
			if (settingData?.security?.cloudflare_turnstile?.wordpress_comment == 1) score += 1;

			if (settingData?.security?.login_limit?.enable == 1) score += 1;

			if (settingData?.security?.disable_right_click?.enable == 1) score += 1;
			if (settingData?.security?.disable_right_click?.enable_woocommerce == 1) score += 1;

			if (settingData?.security?.email_blacklist?.enable == 1) score += 1;

			if (settingData?.security?.address_blacklist?.enable == 1) score += 1;
			if (settingData?.security?.address_blacklist?.enable_blacklisted_addresses == 1) score += 1;

			if (settingData?.security?.salt_change?.enable_schedules == 1) score += 1;
			if (settingData?.security?.salt_change?.schedule_reminder == 1) score += 1;
			if (settingData?.security?.salt_change?.schedule_notification == 1) score += 1;

			if (settingData?.security?.api_privacy.enable == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_wp_version == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_plugins == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_themes == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_core_data == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_core_headers == 1) score += 1;
			if (settingData?.security?.api_privacy.strip_user_logins == 1) score += 1;
			if (settingData?.security?.api_privacy.disable_https == 1) score += 1;

			if (settingData?.security?.updates?.disable_translation_updates == 1) score += 1;
			if (settingData?.security?.updates?.vcs_updates == 1) score += 1;
			if (settingData?.security?.updates?.admin_update_nags == 1) score += 1;
			if (settingData?.security?.updates?.email_notifications == 1) score += 1;
			if (settingData?.security?.updates?.core_notifications == 1) score += 1;

			if (settingData?.security?.injection_guard?.overview?.enable == 1) score += 1;

			if (settingData?.security?.recommendations?.disable_anyone_can_register == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_file_editors == 1) score += 1;
			if (settingData?.security?.recommendations?.prevent_code_execution_uploads_folder == 1) score += 1;
			if (settingData?.security?.recommendations?.hide_wordpress_version == 1) score += 1;
			if (settingData?.security?.recommendations?.prevent_login_feedback == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_user_enumeration == 1) score += 1;
			if (settingData?.security?.recommendations?.unset_x_powered_by_header == 1) score += 1;
			if (settingData?.security?.recommendations?.block_common_usernames == 1) score += 1;
			if (settingData?.security?.recommendations?.change_display_name == 1) score += 1;
			if (settingData?.security?.recommendations?.hide_front_admin_bar == 1) score += 1;
			if (settingData?.security?.recommendations?.hide_back_admin_bar == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_wp_core_auto_updates == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_plugin_auto_updates == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_theme_auto_updates == 1) score += 1;
			if (settingData?.security?.recommendations?.remove_rsd_link == 1) score += 1;
			if (settingData?.security?.recommendations?.remove_wlw_manifest_link == 1) score += 1;
			if (settingData?.security?.recommendations?.remove_shortlink == 1) score += 1;
			if (settingData?.security?.recommendations?.enable_shortcode_in_wp_widgets == 1) score += 1;
			if (settingData?.security?.recommendations?.hide_css_file_version == 1) score += 1;
			if (settingData?.security?.recommendations?.hide_js_file_version == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_dashicons_in_frontend == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_embeds == 1) score += 1;
			if (settingData?.security?.recommendations?.disable_rss_feed == 1) score += 1;
			if (settingData?.security?.recommendations?.remove_rss_feed_links == 1) score += 1;
			if (settingData?.security?.recommendations?.add_feature_image_to_rss_feed == 1) score += 1;

			if (settingData?.restrictions?.settings?.firewall == 1) score += 1;
			if (settingData?.restrictions?.settings?.debug_log == 1) score += 1;

			if (settingData?.security?.comments?.remove_url_field == 1) score += 1;
			if (settingData?.security?.comments?.remove_url_from_comment == 1) score += 1;
			if (settingData?.security?.comments?.remove_url_from_author_name == 1) score += 1;

			if (settingData?.more?.extra?.enable_delete_plugin_data == 1) score += 1;
			if (settingData?.more?.extra?.enable_turnstile_debugging == 1) score += 1;
			
			
			if (settingData?.security?.passkeys?.general_settings?.enable_passkeys == 1) score += 1;
			if (settingData?.security?.passkeys?.general_settings?.max_passkeys_enabled == 1) score += 1;
			if (settingData?.security?.passkeys?.general_settings?.exclude_existing_crdentials == 1) score += 1;
			if (settingData?.security?.passkeys?.general_settings?.enable_user_verification == 1) score += 1;
			if (settingData?.security?.passkeys?.display_settings?.woocommerce_login_form == 1) score += 1;
			if (settingData?.security?.passkeys?.display_settings?.membership_login_form == 1) score += 1;
			if (settingData?.security?.passkeys?.display_settings?.easy_digital_downloads_login_form == 1) score += 1;
			if (settingData?.security?.passkeys?.display_settings?.display_passkeys_in_users_list == 1) score += 1;
			if (settingData?.security?.passkeys?.display_settings?.display_passkeys_in_users_profile == 1) score += 1;


			console.log(score);
			setEnabledScore(score);
		}
	}, [settingData]);
	

    const [fileChecking, setFileChecking] = useState(false)
    const [fileChecked, setFileChecked] = useState(false)
    const [fileChanged, setFileChanged] = useState([])
    const [fileCheckedRecently, setFileCheckedRecently] = useState(false)
    const [filecheckingError, setFilecheckingError] = useState(false)
	const handleFileCheck = async () => {
		setFileChecking(true);
		try {
			const results = await apiFetch({
				path: "/ultimate-security/v1/core-scan-check-integrity-status",
				method: "GET"
			});
			setFileChanged(results)
			setFileChecked(false)
			setFileChecking(false)
			setFileCheckedRecently(true)
		} catch (error) {
			console.error("Error fetching logs:", error);
			setFilecheckingError(error)
			setFileChecked(false)
			setFileChecking(false)
		}
	}
	const [modalIsOpen, setIsOpen] = React.useState(false);

    function openModal() {
        setIsOpen(true);
    }

    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        // subtitle.style.color = '#f00';
    }

    function closeModal() {
        setIsOpen(false);
    }

	const refreshAll = () => {
		// Set loading to true to start the rotation
		setLoading(true);
		
		// Fetch data
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
		
		// Ensure the rotation lasts at least 1 second
		setTimeout(() => {
		  setLoading(false);
		}, 1000);
	}
	useEffect(()=> {
		fetchLogs();
		fetchPluginList();
		fetchSiteHealthReport();
	},[])

	

	const fetchLogs = async () => {
		try {
			const results = await apiFetch({
				path: "/ultimate-security/v1/get-login-failed-logs",
				method: "GET"
			});

			setTotalFailed(results.total_failed || 0);
			setRecentFailed(results.recent_failed || 0);
			setLogs(results.logs || []);
		} catch (error) {
			console.error("Error fetching logs:", error);
		}
	};

	
	const fetchPluginList = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/update-plugin-info", 
				method: "GET" 
			});
			
			// console.log("Raw API response:", results);
	
			const pluginList = Array.isArray(results.plugins_with_updates) ? results.plugins_with_updates : [];
			
	
			setUpdatedPluginList(pluginList);
			setOutdatedPLuginsNumber(pluginList.length);
	
		} catch (error) {
			// console.error("Error fetching PluginList:", error);
			setUpdatedPluginList([]); // fallback to empty list
			setOutdatedPLuginsNumber(0); // reset count
		}
	};
	
	const fetchSiteHealthReport = async () => {
		try {
			const results = await apiFetch({ 
				path: "/ultimate-security/v1/site-health-report", 
				method: "GET" 
			});
			// console.log(results);
			setSiteHealthStatus(results.status);
			setTotalIssues(results.total_issues);
			setCriticalThreats(results.critical_count);
			setSiteHealthReport(results.critical_issues);
			
			
		} catch (error) {
			// console.error("Error fetching Report:", error);
		}
	};

	// For data table
    const [tableData, setTableData] = useState([])
    const [filteredTableData, setFilteredTableData] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [reloadDatatable, setReloadDatatable] = useState(0)
    const filterList = [
        { name: 'All', value: 'all' },
        { name: 'Missing', value: 'Missing' },
        { name: 'Modified', value: 'Modified' },
        { name: 'Unknown', value: 'Unknown' },
    ];    

    const [activeFilter, setActiveFilter] = useState('all')
    const columns = [
        {
            name: 'File',
            selector: row => row.file,
            sortable: true,
        },
        {
            name: 'Reason',
            selector: row => row.reason,
            sortable: true,
        },
    ];

    // Get table data
    useEffect(() => {        
        // setSearchQuery('');
        // setActiveFilter('all'); // Reset the active role
        // const getTableData = async () => {
        //     try {
        //         const response = await apiFetch({
        //             path: '/ultimate-security/v1/core-scan-check-integrity-status',
        //             method: 'GET'
        //         });    
        //         setTableData(response);
        //         setFilteredTableData(response);             
        //     } catch (error) {
        //         console.error(error);
        //     }
        // };    
        // getTableData();
		setTableData(fileChanged)
		setFilteredTableData(fileChanged)
    }, [reloadDatatable, fileChanged]);

    const handleDatatableSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setActiveFilter('all'); // Reset the active role
        const newData = tableData.filter(row => {
            // return row.param.toLowerCase().includes(query.toLowerCase());
            return (
                row.file.toLowerCase().includes(query) ||
                row.reason.toLowerCase().includes(query)
            );
        });
        setFilteredTableData(newData);
    }

    const handleDatatableFilter = (status) => {
        setActiveFilter(status); // Set the active role
        setSearchQuery('');
        if (status === 'all') {
            setFilteredTableData(tableData);        
        } else {
            const newData = tableData.filter(row => {
                return row.reason.toLowerCase().includes(status.toLowerCase());
            });
            setFilteredTableData(newData);        
        }
    }   
    // For data table


	return (
		<div className="ultimate-security-dashboard-content">
			{/* {console.log(settingData)} */}
			<div className="mb-3 text-end">				
				<img className={loading ?'rotate':''} src={ultimate_security_ajax_obj.imageUrl+'ipReload.svg'} alt="" onClick={refreshAll} />
			</div>
			<div className="row mb-3">
				{/* Congratulation */}
				<div className="col-xl-3 col-lg-6 mb-3 mb-xl-5">
					<div className="dash-card option-enabled-dash-card" style={{height: "196px"}}>
						<div className="card-body p-4 h-100">
							<div className="row align-items-stretch h-100">
								<div className="col-6">
									<h5 className="card-title m-0 mb-4">{__("Security Meter", "ultimate-security")}</h5>
									<div>{__("Each Security Feature you use adds a point", "ultimate-security")}</div>
								</div>
								<div className="col-6">
									<div 
										className="d-flex justify-content-between flex-column h-100 score-area"
										// style={{backgroundColor: "#873EFF"}}
									>
										<div className="option-enabled-header text-center">
											<div className="score">{enabledScore}</div>
											<div 
												className="unit"
												style={{color: "#6BD2D1", fontWeight: 600}}
											>Points</div>
										</div>
										{/* <div className="option-enabled-footer text-center">
											<img src={ultimate_security_ajax_obj.imageUrl+'goldenCup.svg'} alt="" />
											<span>EXPLORE</span>
										</div> */}
									</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>				
				<div className="col-xl-3 col-lg-6 mb-3 mb-xl-5">
					<div 
						className="dash-card"  
						style={{height: "196px", overflow: 'hidden'}}
					>
						<div 
							className="card-body p-0 row g-0 h-100"
							style={{margin: "-1px"}}
						>							
							<div className="col-6 d-flex align-items-center dashboard-item border-end border-bottom">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									<img src={ultimate_security_ajax_obj.imageUrl+'issues_found.svg'} alt="icon" width="44px" height="44px" />
								</div>
								<div>
									<h2 className="pl-heading-1 mb-0 fw-bold">{totalIssues}</h2>
									<p className="text-text mb-0 small">
										{__("Issues Found", "ultimate-security")}
									</p>
								</div>
							</div>
							<div className="col-6 d-flex align-items-center dashboard-item border-bottom">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									<img src={ultimate_security_ajax_obj.imageUrl+'critical_threats.svg'} alt="icon" width="44px" height="44px" />
								</div>
								<div>
									<h2 className="pl-heading-1 mb-0 fw-bold">{criticalThreats}</h2>
									<p className="text-text mb-0 small">
										{__("Critical Threats", "ultimate-security")}
									</p>
								</div>
							</div>
							<div className="col-6 d-flex align-items-center dashboard-item border-end">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									<img src={ultimate_security_ajax_obj.imageUrl+'outdated_plugins.svg'} alt="icon"  width="44px" height="44px"/>
								</div>
								<div>
									<h2 className="pl-heading-1 mb-0 fw-bold">{outdatedPLuginsNumber}</h2>
									<p className="text-text mb-0 small">
										{__("Outdated Plugins", "ultimate-security")}
									</p>
								</div>
							</div>							
							<div className="col-6 d-flex align-items-center dashboard-item">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									<img src={ultimate_security_ajax_obj.imageUrl+'failed_logins.svg'} alt="icon" width="44px" height="44px" />
								</div>
								<div>
									<h2 className="pl-heading-1 mb-0 fw-bold">{totalFailed}</h2>
									<p className="text-text mb-0 small">
										{__("Failed Logins", "ultimate-security")}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Security Status */}
				<div className="col-xl-3 col-lg-6 mb-3 mb-xl-5">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4">
							<h5 
								className="card-title"
								style={{ margin: "0px", marginBottom: "24px" }}
							>
								{__("Security Status", "ultimate-security")}
							</h5>
							<div className="d-flex align-items-center">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									<img src={siteHealthStatus === "good" ? ultimate_security_ajax_obj.imageUrl+'good.svg' : ultimate_security_ajax_obj.imageUrl+'critical.svg' } alt="iocn" width="44px" height="44px" />
								</div>
								<div>
									<h4 className="pl-heading fw-bold mb-1">{__(siteHealthStatus, "ultimate-security")}</h4>
									<p className="mb-0">
										{siteHealthStatus === "good" ? __("Your site is protected and no issues detected.","ultimate-security") : __("Your site is not protected.","ultimate-security")}	
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* File Integrity */}
				<div className="col-xl-3 col-lg-6 mb-3 mb-xl-5">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4">
							<div className="row align-items-stretch">
								<div className="col-6">
									<div 
										className="file-status-result h-100" 
										// style={{backgroundColor: !fileCheckedRecently?'#333333':fileChanged.length ? '#D53637':'#28A745'}}
										style={{backgroundColor: '#873EFF'}}
									>
										{
											!fileCheckedRecently?'Not Checked':fileChanged.length ? 'Found Modified Files':'Looks Good'
										}
										{
											// console.log(fileChanged)
										}
									</div>
								</div>
								<div className="col-6">
									<div className="d-flex align-items-center gap-1  mb-2">
										{/* <Hint content={__("No Hints.", "ultimate-security")}/> */}
										<h5 className="card-title m-0">{__("File Integrity", "ultimate-security")}</h5>
									</div>
									<div className="mb-2">{__("Check your core files using checksum.", "ultimate-security")}</div>
									<div className="d-flex align-items-center gap-2"> 
										{
											fileChanged.length ?
												<button 
													className="button button-primary"
													onClick={openModal}
													disabled={fileChecking}
												>
													{__( "View Changes", "ultimate-security" )}                                                
												</button> : 
												<button 
													className="button button-primary"
													onClick={handleFileCheck}
													disabled={fileChecking}
												>
													{fileChecking ? __( "Checking...", "ultimate-security" ) : __( "Check Now", "ultimate-security" )}                                                
												</button>
										}                                          
										
										{fileChecking && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
										{/* {fileChecked && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>} */}
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
				{/* Failed Login Attempts */}
				<div className="col-xl-3 col-lg-6 mb-3">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4">
							<h5 
								className="card-title"
								style={{ margin: "0px", marginBottom: "24px" }}
							>
								{__("Failed Login Attempts", "ultimate-security")}
							</h5>
							<div className="d-flex align-items-center">
								<div
									className="me-3 d-flex align-items-center justify-content-center"
									style={{ width: "50px", height: "50px" }}
								>
									 <img src={ultimate_security_ajax_obj.imageUrl+'failed_login_attempt.svg'} alt="icon" width="44px" height="44px" />
								</div>
								<div>
									<p className="mb-0 fw-medium">
										{recentFailed>0 ? __(recentFailed,"ultimate-security") : __("Hooray! Zero ","ultimate-security")} {__("failed login attempts in the (past 24 hours)", "ultimate-security")}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* Login Attempts */}
				<div className="col-xl-3 col-lg-6 mb-3">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4">
							<h5 
								className="card-title"
								style={{ margin: "0px", marginBottom: "24px" }}
							>
								{__("Login Attempts", "ultimate-security")}
							</h5>
							<ul 
								className="list-unstyled"
								style={{ marginBottom: "0px", height: "105px", overflowY: "auto" }}
							>
								{logs.slice(0, 5).map((log, index) => (
									<li key={index} className="mb-2" style={{ fontSize: "13px" }}>
										{log.success ? "✓" : "✗"}{" "}
										<strong>{log.success ? __("Successful", "ultimate-security") : __("Failed", "ultimate-security")}</strong> {__("login by", "ultimate-security")}{" "}
										<code>{log.username}</code> {__("at", "ultimate-security")}{" "}
										{new Date(log.timestamp * 1000).toLocaleString()} {__("from", "ultimate-security")}{" "}
										<code>{log.ip}</code>
									</li>
								))}
							</ul>

						</div>
					</div>
				</div>
				{/* Plugin Updates */}
				<div className="col-xl-3 col-lg-6 mb-3">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between">
								<h5 
									className="card-title"
									style={{ margin: "0px", marginBottom: "24px" }}
								>
									{__("Plugin Updates", "ultimate-security")}
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'plugins.php?plugin_status=upgrade'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									{__("VIEW UPDATES", "ultimate-security")}
								</a>
								
							</div>
							<ul 
								className="list-unstyled"
								style={{ marginBottom: "0px", height: "105px", overflowY: "auto" }}
							>
								{updatedPluginList.slice(0, 5).map((plugin, index) => (
								<li key={index} className="mb-2" style={{ fontSize: "13px" }}>
									{plugin.name} - <span className="fw-bold text-danger">
									{plugin.current_version || "Unknown"} → {plugin.new_version}
									</span>
								</li>
								))}
							</ul>
						</div>
					</div>
				</div>
				{/* Critical Threats */}
				<div className="col-xl-3 col-lg-6 mb-3">
					<div className="dash-card " style={{height: "196px"}}>
						<div className="card-body p-4 d-flex flex-column">
							<div className="d-flex justify-content-between">
								<h5 
									className="card-title"
									style={{ margin: "0px", marginBottom: "24px" }}
								>
									{__("Critical Threats", "ultimate-security")}
								</h5>
								<a
									href={ultimate_security_ajax_obj.admin_url + 'site-health.php'}
									className="text-decoration-none small"
                                    style={{color: "#873EFF"}}
								>
									{__("VIEW ALL", "ultimate-security")}
								</a>
							</div>
							<ul 
								className="list-unstyled"
								style={{ marginBottom: "0px", height: "105px", overflowY: "auto" }}
							>
								{siteHealthReport.slice(0, 5).map((report, index) => (
									<li key={index} className="mb-2">
										<span className="pl-heading-1fw-bold text-danger">{__(report.label, "ultimate-security")}</span>
									</li>
								))}
								
							</ul>
						</div>
					</div>
				</div>
				
				
				
			</div>
			<Modal
				isOpen={modalIsOpen}
				onAfterOpen={afterOpenModal}
				onRequestClose={closeModal}
				style={customStyles}
				contentLabel="Example Modal"
			>
				<div 
					className="file-list-wrapper"
					// style={{position: 'relative', padding: '0px'}}
				>
					{/* <button onClick={closeModal}>close</button> */}
					{/* {console.log(fileChanged)} */}
					{/* {console.log(filteredTableData)} */}
					
					<div className="modalHeader">
						<h4 className="modalTitle">{__('View Files', 'ultimate-security')}</h4>
						<div className="modalIntro">{__('See a list of all the files checksum checked. They have categorized below for your convenience.', 'ultimate-security')}</div>
						<div className="modalHelp">ℹ️ {__('Keep in mind not all unkown, modified files are malicious. Your installed plugins, themes and other services might be using them. Double check before changing anything.', 'ultimate-security')}</div>
					</div>
					<div className="user-datatable datatable-unit">
						<div className="row align-items-center mb-30">
							<div className="col-7 datatable-filters">
								<div className="d-flex flex-wrap">
									{
										filterList && filterList.map(item => (                                        

											<span 
												key={item.role} 
												onClick={() => handleDatatableFilter(item.value)}
												className={activeFilter === item.value ? 'active' : ''}
											>
												{item.name} 
											</span> 

										))      
									}
								</div>
							</div>
							<div className="col-5">
								<div className="search-unit d-flex gap-2 align-items-stretch justify-content-end">
									<input 
										placeholder="Search" 
										type="search" 
										onChange={handleDatatableSearch} 
										value={searchQuery} 
									/>
									<button className="button button-secondary" type="button">
										{__('Search', 'ultimate-security')}
									</button>
								</div>
							</div>
						</div>            
						<div className="table-wrapper border">
							<DataTable
								columns={columns}
								data={filteredTableData} // Use filtered data
								pagination
								paginationPerPage={5} // Default to 5 rows per page
								paginationRowsPerPageOptions={[5, 10]} // Options with 5 first
								dense
								responsive
							/>
						</div> 
					</div>					
				</div>
			</Modal>
		</div>
	);
}
